import React, { Component } from 'react'
import i18n from 'i18next'

import Button from '../../../UniformComponents/Button'
import Modal from '../../../UniformComponents/Modal'

class SubmitModal extends Component {
    constructor(props) {
        super(props)
        this.presentationStore = props.presentationStore
        this.state = {
            downloadComplete: false,
        }
    }

    renderContent = () => {
        const {
            status,
        } = this.props
        let content
        if (status !== 200 && status !== null) {
            content = (
                <div className="uc-modal__header">
                    <h2>{i18n.t('presentation.modal.download.title.failure')}</h2>
                    <p className="uc-modal__desc">{i18n.t('presentation.modal.download.desc.failure')}</p>
                </div>
            )
        } else {
            content = (
                <div className="uc-modal__header">
                    <h2>{i18n.t('presentation.modal.download.title.success')}</h2>
                    <p className="uc-modal__desc">{i18n.t('presentation.modal.download.desc.success')}</p>
                </div>
            )
        }
        return content
    }

    renderComplete = () => (
        <>
            <div className="uc-modal__header">
                <h2>{i18n.t('presentation.modal.download.title.success')}</h2>
                <p className="uc-modal__desc">{i18n.t('presentation.modal.download.title.success')}</p>
            </div>
            <div>
                <i className="fa-solid fa-circle-check submit-modal-download-success-icon" />
            </div>
        </>
    )

    render() {
        const {
            status,
            modalStatus,
            handleSubmitModal,
            response,
            handleDownload,
        } = this.props
        const { downloadComplete } = this.state
        return (
            <Modal
                show={modalStatus}
                onClose={handleSubmitModal}
            >
                <div id="submit-modal">
                    {!downloadComplete ? this.renderContent() : this.renderComplete()}
                    <div className="uc-modal__button-panel">
                        <Button
                            onClick={handleSubmitModal}
                            cssClass="tertiary regular btn"
                        >
                            {i18n.t('close')}
                        </Button>
                        {!(status !== 200 && status !== null) && !downloadComplete && (
                            <a
                                href={response}
                                // onClick={handleDownload}
                                className="uc-button primary regular btn"
                            >
                                <i className="fa-solid fa-folder-arrow-down" />
                                {' '}
                                {i18n.t('download')}
                            </a>
                        )}
                    </div>
                </div>
            </Modal>
        )
    }
}

export default SubmitModal
